module.exports = __webpack_public_path__ + "img/P150T_weapon_70.523fc28c.png";